// extracted by mini-css-extract-plugin
export default {"input":"LabeledCurrencyInput_input__1RyDf"};